import { useQuery } from "@apollo/client";

import { GameKind } from "../../gql/graphql";
import { GameResults } from "../GameResults";
import { QUICKRANK_GAME_RESULTS, RANKIFIER_GAME_RESULTS, SWIPER_GAME_RESULTS } from "../../graphql/queries/Project";
import { useGlobalConfiguration } from "../../hooks/useGlobalConfiugration";
import { CardBasedGame } from "../../graphql/helpers/CardBasedGame";

export interface GameResultsPageProps {
  game: CardBasedGame;
  responseId: string;
  onConfirm: () => void;
}

export const GameResultsPage = ({ game, responseId, onConfirm }: GameResultsPageProps) => {
  const { isPreviewMode } = useGlobalConfiguration();

  const { data: swiperData } = useQuery(SWIPER_GAME_RESULTS, {
    variables: { responseId },
    skip: game.kind !== GameKind.Swiper || isPreviewMode,
  });

  const { data: rankifierData } = useQuery(RANKIFIER_GAME_RESULTS, {
    variables: { responseId },
    skip: game.kind !== GameKind.Rankifier || isPreviewMode,
  });

  const { data: quickrankData } = useQuery(QUICKRANK_GAME_RESULTS, {
    variables: { responseId },
    skip: game.kind !== GameKind.QuickRank || isPreviewMode,
  });

  const previewModeMock = isPreviewMode ? 50 : 0;

  return (
    <GameResults
      result={
        swiperData?.swiperGameResults.match ||
        rankifierData?.rankifierGameResults.match ||
        quickrankData?.quickRankGameResults.match ||
        previewModeMock
      }
      themeColor={game.configuration.gameVisuals.themeColor}
      onConfirm={onConfirm}
      config={game.configuration.gameResults}
    />
  );
};
